import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { Button, BUTTON_LAYOUTS, Modal } from 'components/UI'
// views
import { Text, Header, ButtonContainer } from './views'
// constants
import { Modals } from 'constants/modals'

const CheckMandatoryModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, width, text, title }
  } = useModalData({ modalType: Modals.RISK_MANDATORY_CHECK_MODAL })

  const onCancelClick = () => {
    hideModal()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal hideModal={onCancelClick} isOpen={isOpen} width={width} PaperProps={{ style: { width: '554px' } }}>
      <Header handleClearClick={onCancelClick}>{title}</Header>
      <Text>{text}</Text>
      <ButtonContainer>
        <Button layout={BUTTON_LAYOUTS.RED} onClick={onCancelClick}>
          Close
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

export default CheckMandatoryModal
